import { merge } from 'lodash';
import VueI18n from 'vue-i18n';

import { fetchLocale } from './fetch-locale';

declare const FALLBACK_LOCALE;

let instance: VueI18n = null as any;

export function createInstance(messages, locale = FALLBACK_LOCALE, dateTimeFormats) {
    return new VueI18n({
        dateTimeFormats,
        fallbackLocale: FALLBACK_LOCALE,
        locale,
        messages,
    });
}

export async function i18n(messages, dateTimeFormats) {
    if (instance) {
        return instance;
    }

    const locale = localStorage.getItem('preferredLocale') || navigator.language.split('-')[0] || FALLBACK_LOCALE;
    let remoteMessages = {};

    try {
        remoteMessages = await fetchLocale(locale);
    } catch (error) {
        // tslint:disable-next-line:no-console
        console.error(error);
    }

    instance = createInstance(merge(remoteMessages, messages), locale, dateTimeFormats);

    return instance;
}
